module.exports = __webpack_public_path__ + "static/media/notfound.9ed0fc02.svg";